// removed by extract-text-webpack-plugin
module.exports = {"card":"styles--card--2jq5nI2p"};


//////////////////
// WEBPACK FOOTER
// ./src/App/account/components/Surveys/QuestionGroup/styles.css
// module id = 1225
// module chunks = 2